import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfSomaOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'soma',
  neighborhoodDisplayName: 'SoMa',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 31,
  whereFromStreetsToLandmark:
    'from the buildings along Annie St, Brannan St, and Howard St to the clusters near Caltrain Station',
  whereTeamStreets: 'Annie St, Brannan St, Howard St, Townsend St',
  clientDescriptor: 'around 125 people software startup near Townsend St',
  clientDescriptorByService: {
    cleaning: 'a small team tech startup near Townsend St',
    officeAssistant: 'a small team tech startup near Townsend St',
    officeFurniture: 'a small team tech startup near Townsend St'
  },
  counts: {
    managedCleaningOffices: 14,
    managedPantryOffices: 31,
    managedInternetOffices: 31,
    managedFurnitureOffices: 14,
    managedOfficeAssistantOffices: 14,
    managedDeepCleaningOffices: 8,
    managedCarpetCleaningOffices: 6,
    managedWindowCleaningOffices: 5,
    managedGlassCleaningOffices: 10,
    managedWasteRecyclingOffices: 9,
    managedPantryInventoryOffices: 22,
    managedCoffeeServiceOffices: 18,
    managedWaterServiceOffices: 16,
    managedTeamLunchOffices: 8,
    managedBreakfastCateringOffices: 6,
    managedIndividualMealsOffices: 5,
    managedAdHocCateringOffices: 9,
    managedHappyHourOffices: 7,
    managedConferenceRoomAvOffices: 12,
    managedNetworkInstallationOffices: 22,
    managedNetworkManagementOffices: 16,
    managedCableManagementOffices: 10,
    managedRoomBookingOffices: 9,
    managedPrintingSetupOffices: 14,
    managedInteriorDesignOffices: 11,
    managedOfficeMuralsOffices: 5,
    managedOfficePaintingOffices: 7,
    managedGlassFrostingOffices: 8,
    managedOfficeSignageOffices: 6,
    managedCareRoomOffices: 4,
    managedFurnitureAssemblyOffices: 14,
    managedLayoutChangeOffices: 9,
    managedOfficePlantsOffices: 12,
    managedKeylessAccessOffices: 14,
    managedAlarmSystemsOffices: 8,
    managedSecurityCamerasOffices: 12,
    managedKeypadOffices: 10,
    managedLockboxOffices: 6,
    managedVisitorManagementOffices: 9,
    managedBusinessInsuranceOffices: 11,
    managedElectricalServicesOffices: 10,
    managedHvacOffices: 8,
    managedPlumbingOffices: 7,
    managedPestControlOffices: 6,
    managedOfficeMovingOffices: 9,
    managedMountingInstallationOffices: 12
  },
  quotes: {
    cleaning: 'We needed someone to just handle it \u2014 weekly cleaning, pantry, the whole thing.',
    pantryRestocking: 'We were ordering on Instacart ourselves. Now Codi handles the restocking automatically.',
    internet: 'IT setup is the first thing you need and the last thing you want to deal with.',
    officeAssistant: 'Building staff drop-ins, packages, pantry restock \u2014 it all needs a person on site.',
    officeFurniture: 'The build-out was massive. Codi managed 8 major projects in 5 weeks.',
    deepCleaning: 'Quarterly deep cleans used to be a whole project to coordinate. Codi just handles it.',
    carpetCleaning: 'The carpets were overdue and we had no idea who to call. Codi sorted it in a week.',
    windowCleaning: 'High-rise window cleaning is not something you want to manage yourself. Codi does.',
    glassConferenceRoom: 'Glass walls look terrible when they\u2019re smudged. Codi keeps them spotless.',
    wasteRecycling: 'SF composting rules are strict. Codi makes sure we stay compliant without thinking about it.',
    pantryInventory:
      'We used to do manual pantry counts every Monday. Codi tracks it automatically and reorders before we run out.',
    coffeeService:
      'The coffee machine was always running low or broken. Codi handles everything \u2014 beans, maintenance, the works.',
    waterService:
      'Filtered water dispenser setup was a mystery. Codi installed it, stocks it, and services it on a schedule.',
    teamLunch:
      'We do a weekly team lunch. Codi books the caterer, handles delivery coordination, and it just shows up.',
    breakfastCatering: 'Monday morning breakfast was always someone\u2019s job. Now it\u2019s Codi\u2019s job.',
    individualMeals:
      'We have a daily lunch program for the team. Codi manages the vendor and the distribution so we don\u2019t have to.',
    adHocCatering: 'Board meeting, client lunch, all-hands \u2014 Codi handles the catering logistics every time.',
    happyHour:
      'We wanted to do Friday happy hours without making it someone\u2019s full-time side project. Codi owns it.',
    conferenceRoomAv:
      'Our conference room was a tangle of adapters and cables. Codi wired it properly and now it just works.',
    networkInstallation: 'New office, no network. Codi had us wired and on managed wifi before the desks arrived.',
    networkManagement: 'Codi monitors our network and handles any issues before the team even notices there was one.',
    cableManagement: 'Under-desk cable chaos was embarrassing in client meetings. Codi cleaned it all up in a day.',
    roomBooking: 'Conference rooms were always double-booked. Codi deployed room tablets and it stopped immediately.',
    printingSetup: 'Printer setup took three IT calls before Codi stepped in. They had it running in two hours.',
    interiorDesign:
      'We needed a full space plan before signing the lease. Codi came in, scoped it, and managed the entire fit-out.',
    officeMurals:
      'We wanted something on the wall that felt like us. Codi found the artist, handled permitting, and it went up without us lifting a finger.',
    officePainting:
      'The walls needed a refresh before the all-hands. Codi scheduled after-hours painters and it was done by morning.',
    glassFrosting:
      'Open conference rooms felt awkward. Codi installed frosted film on all the glass panels in one afternoon.',
    officeSignage:
      'We had a blank lobby wall for months. Codi designed, fabricated, and installed the signage in a week.',
    careRoom:
      'Setting up a dedicated care room was on the list forever. Codi handled the furniture, curtain, and electrical in one visit.',
    furnitureAssembly:
      'We had 40 desks arriving on a Tuesday. Codi had a crew there and everything assembled by end of day.',
    layoutChange:
      'We needed to reorganize the whole floor. Codi moved everything over a weekend and had cables routed before Monday.',
    officePlants:
      'The office felt sterile. Codi brought in plants, placed them well, and comes back monthly to keep them alive.',
    keylessAccess:
      'We needed keyless access from day one. Codi installed the system, set up credentials, and manages access remotely.',
    alarmSystems:
      'The building required a monitored alarm before we could move in. Codi handled vendor selection, install, and ongoing testing.',
    securityCameras:
      'We wanted cameras at the entry and server room. Codi installed everything and set up remote access for the team.',
    keypads:
      'Keypads on every door keeps the office secure without key management hassle. Codi installed and manages the codes.',
    lockboxes:
      'We needed a lockbox for vendor access during off-hours. Codi coordinated placement with building security.',
    visitorManagement:
      'Our SoMa office gets a lot of guests. Codi deployed a visitor management system that handles check-in, badges, and compliance.',
    businessInsurance:
      'Building required COI updates every renewal. Codi coordinates our business insurance and handles certificate requests.',
    electricalServices:
      'We needed new outlets and a panel upgrade before moving in. Codi handled permits, found a licensed electrician, and got it done before our lease started.',
    hvac: 'The HVAC system was temperamental from day one. Codi coordinated the service vendor and now it just gets handled before anyone complains.',
    plumbing:
      'A slow drain became a flooded bathroom. Codi had a plumber out same day and now manages preventive maintenance so it doesn\u2019t happen again.',
    pestControl:
      'SoMa buildings can have issues. Codi schedules quarterly pest control and we haven\u2019t had a problem since.',
    officeMoving:
      'Moving across SoMa with 40 employees worth of furniture sounded like a nightmare. Codi managed the whole thing \u2014 trucks, crew, and building coordination.',
    mountingInstallation:
      'We had a dozen TVs and whiteboards to mount across three floors. Codi sent a crew and had everything up and level in one day.'
  },
  officeAssistant: {}
});
